import {
  avatarButtonContainerStyles,
  avatarContainerStyles
} from '../../../../../common/person/edit/basic-info/person-basic-information-styles'
import { Avatar, Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { usGetPersonPicture } from 'services'
import { type PersonPictureInformation } from 'services/person/us/picture/personGetPicture'
import UploadBinaryLogo from './upload-binary-logo'
import CircularProgress from '@mui/material/CircularProgress'
import { useGlobalMessageHandler, LastUpdatedComponent, IconButtonWithTooltip } from 'components'
import { PersonPhotoGallery } from './person-photo-gallery'
interface PersonLogoProps {
  personId: number
  personName: string
  loading?: boolean
}
export const PersonLogoBinary: React.FC <PersonLogoProps> = ({ personName, personId, loading: externalLoading = false }) => {
  const [imageLink, setImageLink] = useState<PersonPictureInformation>({})
  const [imageLoading, setImageLoading] = useState<boolean>(false)
  const [galleryOpen, setGalleryOpen] = useState(false)
  const { showErrorMessage, clearMessages } = useGlobalMessageHandler()

  useEffect(() => {
    setImageLink({})
    if (personId === 0) return
    clearMessages()
    setImageLoading(true)
    usGetPersonPicture(personId).then((value) => {
      if (value.result != null) { setImageLink(value.result) }
    }).catch((error) => {
      if (error.request.status !== 404) {
        showErrorMessage('Error getting person picture')
      }
    })
      .finally(() => { setImageLoading(false) })
  }, [personId])

  return (
        <Box sx={avatarContainerStyles}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Box sx={avatarButtonContainerStyles}>
                                  <IconButtonWithTooltip
                                    label="View all photos"
                                    onClick={() => { setGalleryOpen(true) }}
                                    sx={{ p: 0 }}
                                    icon={
                                      !(imageLoading || externalLoading)
                                        ? <Avatar
                                              alt={personName}
                                              src={(imageLink.image != null) ? 'data:image/jpeg;base64,' + imageLink.image : undefined}
                                              sx={{ width: 125, height: 125, fontSize: 80 }}
                                          />
                                        : <CircularProgress size={125} />
                                    }
                                  />

                                </Box>
                        <Box sx={avatarButtonContainerStyles}>
                          <UploadBinaryLogo personId={personId} setImageLink={setImageLink}/>
                        </Box>
                        {imageLink.last_updated != null && (
                          <LastUpdatedComponent label="Photo Last Updated" value={String(imageLink.last_updated)}/>
                        )}
                        <PersonPhotoGallery personId={personId} open={galleryOpen} onClose={() => { setGalleryOpen(false) }} setImageLink={setImageLink} />
                    </Box>
        </Box>
  )
}
